/** Escape a value for use inside a double-quoted JQL string literal. */
export function jqlString(value: string): string {
  return `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
}

/**
 * Heuristic: treat input as raw JQL when it uses an operator or an (uppercase)
 * JQL keyword. Lowercase "and"/"or" stay plain-text searches.
 */
export function looksLikeJql(input: string): boolean {
  return /[=~<>]|!=|\s(AND|OR|NOT|IN|IS)\s|\bORDER BY\b/.test(input);
}
